import React, { useState } from 'react';
import { Plus, ArrowUp } from 'lucide-react';
import BlockMenuOverlay from './BlockMenuOverlay';

const AddBlockMenu = ({ onAddContent, label = 'Add Block', variant = 'default' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (type) => {
    onAddContent && onAddContent(type);
    setIsOpen(false);
  };

  const buttonClasses =
    variant === 'top'
      ? 'border-2 border-dashed border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:border-emerald-400'
      : 'border-2 border-dashed border-blue-300 bg-blue-50 text-blue-700 hover:bg-blue-100 hover:border-blue-400';

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={() => setIsOpen(true)}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg transition-all shadow-sm ${buttonClasses}`}
      >
        <Plus size={14} />
        {variant === 'top' && <ArrowUp size={14} />}
        <span className="text-xs font-semibold">{label}</span>
      </button>
      <BlockMenuOverlay
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default AddBlockMenu;

